import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import ContactUsLanding from "../views/ContactUsLanding";

export default function ContactUs() {

	const appContext = useContext(AppContext);

	const [ view, setView ] = useState(null);

	useEffect(() => {
		if(
			!appContext.navSubItem &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			setView(<ContactUsLanding/>);
		} else {
			setView(null);
		}
	}, [ appContext.navSubItem, appContext.navExtraItem, appContext.navMoreItem ])

	//return desired view
	return view;
}
